import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthService } from '../../services';
import { UserPanelComponent } from '../user-panel/user-panel.component';
import { DxButtonComponent } from 'devextreme-angular/ui/button';
import { DxToolbarComponent } from 'devextreme-angular/ui/toolbar';
import { NavigatorService } from '../../services/navigator.service';
import {
  DxContextMenuComponent,
  DxDropDownButtonComponent,
  DxTemplateDirective,
} from 'devextreme-angular';
import { Utente } from 'src/app/models/utente';
import { StorageService } from '../../services/storage.service';
import { AlertService } from '../../services/alert.service';
import { Alert } from 'src/app/models/alert';
import { Subscription } from 'rxjs';
import { DxiItemComponent } from 'devextreme-angular/ui/nested';
import { RUOLO_OPERATORE_BASE } from 'src/app/consts/const';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    CommonModule,
    DxButtonComponent,
    UserPanelComponent,
    DxToolbarComponent,
    DxButtonComponent,
    DxDropDownButtonComponent,
    DxContextMenuComponent,
    DxiItemComponent,
    DxTemplateDirective,
  ],
  standalone: true,
})
export class HeaderComponent implements OnInit {
  private authService = inject(AuthService);
  private navService = inject(NavigatorService);
  private alertService = inject(AlertService);
  private ss = inject(StorageService);

  alertSubscript: Subscription;

  @Output()
  menuToggle = new EventEmitter<boolean>();

  @Input()
  menuToggleEnabled = false;

  @Input()
  title: string;

  user = { email: '' };

  userMenuItems = [
    {
      text: 'Cambio password',
      icon: 'user',
      onClick: () => {
        this.goToResetPassword();
      },
    },
    {
      text: 'Logout',
      icon: 'runner',
      onClick: () => {
        this.authService.logOut();
      },
    },
    {
      text: 'Logout da M365',
      icon: 'runner',
      onClick: () => {
        this.authService.logOutFromMicrosoft();
      },
    },
  ];

  //Azioni veloci
  azioniVeloci: string[];

  utente: Utente;
  logoDitta: string;
  listAlert: Alert[];
  countAlert: number;

  dataSource: any;

  isBase: boolean = true;

  constructor() {
    this.isBase = this.ss.utenteCorrente.ruoloString == RUOLO_OPERATORE_BASE;
    this.alertSubscript = this.alertService.getClickEvent().subscribe(() => {
      this.getAlert();
    });

    this.azioniVeloci = [
      'Nuovo dipendente',
      'Nuova consegna a dipendente',
      'Nuova movimentazione',
    ];

    this.dataSource = [
      {
        text: 'Lorem Ipsum is simply dummy text',
        icon: 'dx-icon-warning',
        // items: [
        //     { text: 'Facebook' },
        //     { text: 'Twitter' }]
      },
      { text: 'Lorem Ipsum is simply dummy text', icon: 'dx-icon-user' },
      { text: 'Lorem Ipsum is simply dummy text ', icon: 'dx-icon-warning' },
      { text: 'Lorem Ipsum is simply dummy text', icon: 'dx-icon-warning' },
    ];
  }

  ngOnInit(): void {
    this.ss.utenteAggiornato.subscribe((u) => (this.utente = u));

    //Logo ditta
    this.logoDitta =
      'assets/' + this.utente?.infoDitta.dettagliGrafici.pathLogo;
    this.getAlert();
    setInterval(() => {
      this.getAlert();
    }, 60000);
  }

  eseguiAzione(e: any) {
    // console.log('clic azione veloce' + e.itemData.name || e.itemData);

    if (e.itemData.name || e.itemData == 'Nuovo dipendente') {
      this.navService.goToNewDipendente();
    } else if (e.itemData.name || e.itemData == 'Nuova consegna a dipendente') {
      //this.navService.goToNewMovimento();
      this.navService.goToNuovaConsegna();
    } else if (e.itemData.name || e.itemData == 'Nuova movimentazione') {
      this.navService.goToMovimentazioneNew();
    }
  }

  toggleMenu = () => {
    this.menuToggle.emit();
  };

  goToHome = () => {
    this.navService.goToHome();
  };

  goToResetPassword = () => {
    this.navService.goToResetPassword();
  };

  goToProposte() {
    this.navService.goToProposte();
  }

  getAlert() {
    if (this.ss.utenteCorrente.ruoloString != RUOLO_OPERATORE_BASE) {
      this.listAlert = [];
      this.alertService.list().subscribe({
        next: (dati) => {
          this.listAlert = dati;
          this.countAlert = dati.length;
        },
        error: (err) => {
          if (err?.error?.title) {
            notificaMessaggio(err.error.title, 'error');
          } else {
            notificaMessaggio('Errore nel recupero degli alert', 'error');
          }
        },
      });
    }
  }
  goToDipendente(idDipendente) {
    console.log('GoToDip:' + idDipendente);
    this.navService.goToDipendentiDetail(idDipendente);
  }

  goToArticolo(idArticolo: number){
    this.navService.goToArticoliDashboard(idArticolo);
  }

  goToMovimentazioni(){
    this.navService.goToMovimentazioni()
  }
}
